export const TICKET_CATEGORY = [
  { value: 'Travel', label: 'Travel' },
  { value: 'Bonus', label: 'Bonus' },
  { value: 'Performance', label: 'Performance' },
  { value: 'Leave', label: 'Leave' },
  { value: 'Work From Home', label: 'Work From Home' },
  { value: 'Expense', label: 'Expense' },
  { value: 'Over Time', label: 'Over Time' },
  { value: 'Loan', label: 'Loan' },
];

export const TICKET_STATUS = [
  { value: 0, label: 'Open' },
  { value: 1, label: 'Closed' },
  { value: 2, label: 'Pending with Employee' },
  { value: 3, label: 'Withdrawn' },
];

export const TICKET_STATUS_ASSIGNED_TO = [
  { value: 0, label: 'Open' },
  { value: 1, label: 'Closed' },
  { value: 2, label: 'Pending with Employee' },
];

export const TICKET_STATUS_CREATED_BY = [{ value: 3, label: 'Withdrawn' }];

export const TICKET_STATUS_DISPLAY = {
  Open: 'Open',
  Closed: 'Closed',
  Pending: 'Pending with Employee',
  Withdrawn: 'Withdrawn',
};

export const TICKET_STATUS_TYPES = {
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'In Progress',
  WAITING: 'Waiting....',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const CLOSED_TICKET_STATUS = ['Completed', 'Cancelled'];

export const TICKET_STATUS_BADGE_STYLES = {
  Assigned: {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
  },
  Completed: {
    backgroundColor: '#ECFDF3',
    borderColor: '#ABEFC6',
    fontColor: '#067647',
  },
  'In Progress': {
    backgroundColor: '#FFFAEB',
    borderColor: '#FEDF89',
    fontColor: '#B54708',
  },
  'Waiting....': {
    backgroundColor: '#FFFAEB',
    borderColor: '#FEDF89',
    fontColor: '#B54708',
  },
  Cancelled: {
    backgroundColor: '#FEF3F2',
    borderColor: '#FECDCA',
    fontColor: '#B42318',
  },
};
